import { MNavLinkProps, PmRole } from "@material-dev/insights-portal-ui-components/lib";
import { MRouteObject } from "@material-dev/insights-portal-ui-components/lib/feature-components/m-app/types";
import { RequireKey } from "@material-dev/insights-portal-ui-components/lib/types";

import React, { lazy } from "react";
import CompareVersions from "components/CompareSelection"; 

import Home from "components/Home";
import RedirectToDefault from "components/RedirectToDefault";
import { DATASETS_PATH, DATASETS_TITLE, WORKDAY_PROJECT_DATASETS_PATH, WORKDAY_PROJECT_DATASET_VIEW_PATH, WORKDAY_PROJECTS_PATH, WORKDAY_PROJECTS_TITLE } from "const/routes";


export const ADD_PROJECT_PARAM = "addProject";

const AdminConsole = lazy(() => import("../components/AdminConsole"));
const HowItWorks = lazy(() => import("../components/HowItWorks"));
const Datasets = lazy(() => import("../components/Projects"));
const WorkdayProjects = lazy(() => import("../components/WorkDayProjects"));
const WorkdayProject = lazy(() => import("../components/WorkDayDatasets"));
const ProjectData = lazy(() => import("../components/ProjectData"));
const Project = lazy(() => import("../components/Project"));
const ImportInstruction = lazy(() => import("../components/ImportInstruction"));
const DatasetViewContainer  = lazy(()=> import ("components/ProjectData/components/ProjectDataContainers/DatasetViewContainer"));

const ProjectTextViewContainer = lazy(() => import("components/ProjectData/components/ProjectTextView/ProjectTextViewContainer"));
const ProjectIntegrationsViewContainer = lazy(() => import("components/ProjectData/components/ProjectIntegrationsView/ProjectIntegrationsViewContainer"));
const ProjectAICodingPage = lazy(() => import("components/ProjectData/components/ProjectAICoding/ProjectAICodingPage"));
const AICodingJobDetailsPage = lazy(() => import("components/ProjectData/components/ProjectAICoding/AICodingJobDetailsPage"));
const CustomDataDictionaryPage =  lazy(() => import("components/CustomDataDictionaryPage"));
const ProjectHeatmapViewContainer = lazy(() => import("components/ProjectData/components/ProjectHeatmapView/ProjectHeatmapViewContainer"));
const ManualCodeframeContainer = lazy(() => import("components/ProjectData/components/ProjectAICoding/ManualCodeframe/ManualCodeframeContainer"));
const QuickCodeframeContainer = lazy(() => import("components/ProjectData/components/ProjectAICoding/QuickCodeframe/QuickCodeframeContainer"));
const HeatmapPage = lazy(() => import("components/ProjectData/components/ProjectHeatmapView/components/Heatmap/Heatmap"));

const projectChildren: MRouteObject[] = [
  {
    element: <ImportInstruction />,
    path: "import",
  },
  {
    element: <ProjectData />,
    children: [
      {
        element: <DatasetViewContainer />,
        index: true,
      },
      {
        element: <DatasetViewContainer />,
        path: "encoded-data",
      },
      {
        element: <ProjectTextViewContainer />,
        path: "text-data",
      },
      {
        element: <ProjectAICodingPage />,
        path: "ai-coding",
        children: [
          {
            path: "jobs/:jobConfigId",
            element: <AICodingJobDetailsPage />,
            children: [
              {
                path: "manual",
                element: <ManualCodeframeContainer />,
              },
              {
                path: "quick",
                element: <QuickCodeframeContainer />,
              },
            ],
          },
        ],
      },
      {
        element: <ProjectIntegrationsViewContainer />,
        path: "integrations",
      },
      {
        element: <ProjectHeatmapViewContainer />,
        path: "heat-map",
        children: [
          {
            path: ":heatmapId",
            element: <HeatmapPage />,
          }
        ]
      },
    ],
  },
  {
    path: "*",
    element: <RedirectToDefault />,
  },
];

export const AppRoutes: MRouteObject[] = [
  {
    element: <Home />,
    index: true,
  },
  {
    element: <HowItWorks />,
    path: "/howitworks",
  },
  {
    element: <Datasets />,
    path: DATASETS_PATH,
  },
  {
    element: <WorkdayProjects />,
    path: WORKDAY_PROJECTS_PATH,
  },
  {
    element: <WorkdayProject />,
    path: WORKDAY_PROJECT_DATASETS_PATH ,
  },
  {
    element: <AdminConsole />,
    path: "/AdminConsole",
    roles: [PmRole],
  },
  {
    element: <Project />,
    path: `${DATASETS_PATH}/:projectId/:encodedVersionId?`,
    children: projectChildren,
  },
  {
    element: <Project />,
    path: `${WORKDAY_PROJECT_DATASET_VIEW_PATH}/:projectId/:encodedVersionId?`,
    children: projectChildren,
  },
  {
    element: <CustomDataDictionaryPage />,
    path: "/customProjects/:projectId/",
  },
  {
    element: <CompareVersions />,
    path: `${DATASETS_PATH}/:referenceProjectId/:referenceVersionId/selection`,
  },
];

export const AppNavigation: RequireKey<MNavLinkProps, "path" | "headerText">[] = [
  {
    headerText: "Home",
    path: "/",
  },
  {
    headerText: "How it works",
    path: "/howitworks",
  },
  {
    headerText: WORKDAY_PROJECTS_TITLE,
    path: WORKDAY_PROJECTS_PATH,
    isExact: true,
  },
  {
    headerText: DATASETS_TITLE,
    path: DATASETS_PATH,
    isExact: true,
  }, 
];

export const ProfileMenuNavigation: RequireKey<MNavLinkProps, "path" | "headerText">[] = [ 
  {
    headerText: "Admin Console",
    path: "/AdminConsole",
    isExact: true,
    role: PmRole,
  },
];
